import { render, staticRenderFns } from "./ListPlegableLegend.vue?vue&type=template&id=5100761a&scoped=true&"
import script from "./ListPlegableLegend.vue?vue&type=script&lang=js&"
export * from "./ListPlegableLegend.vue?vue&type=script&lang=js&"
import style0 from "./ListPlegableLegend.vue?vue&type=style&index=0&id=5100761a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100761a",
  null
  
)

export default component.exports